import React, { useMemo } from "react";
import SimpleListbox, { SimpleOption } from "./SimpleListbox";

export interface SelectListGroup {
	name: string;
	disabled: boolean;
}

export interface SelectListItem {
	value: string | number;
	text: string;
	group?: SelectListGroup;
	disabled?: boolean;
	selected?: boolean;
}

export interface SelectListProps {
	id?: string;
	className?: string;
	selectListItems: SelectListItem[];
	value?: string | number;
	prompt?: string;
	onChange: (value: string) => void;
}

export function SelectList(props: SelectListProps) {
	const simpleOptions = useMemo(
		() =>
			props.selectListItems.map((i) => {
				return {
					value: i.value,
					label: i.text,
				} as SimpleOption;
			}),
		[props.selectListItems]
	);

	const value = props.value ?? props.selectListItems.find((i) => i.selected)?.value;

	return (
		<SimpleListbox
			id={props.id ?? "select-list"}
			options={simpleOptions}
			prompt={props.prompt}
			value={value}
			className={props.className ?? ""}
			onChange={(e) => props.onChange(e.target.value)}
		/>
	);
}
